// Centralized destination image map - reliable Unsplash URLs
// Used by DealCard, PackageCard, and PromotionDetails

const DESTINATION_IMAGES = {
  'santiago': 'https://images.unsplash.com/photo-1689850543263-01a52ccc6943?w=800&h=500&fit=crop',
  'seul': 'https://images.unsplash.com/photo-1760000843601-2070baed2478?w=800&h=500&fit=crop',
  'assunção': 'https://images.unsplash.com/photo-1655425541685-c3d9b0672d9f?w=800&h=500&fit=crop',
  'assuncao': 'https://images.unsplash.com/photo-1655425541685-c3d9b0672d9f?w=800&h=500&fit=crop',
  'méxico': 'https://images.unsplash.com/photo-1547686669-9a8cb1a22d91?w=800&h=500&fit=crop',
  'mexico': 'https://images.unsplash.com/photo-1547686669-9a8cb1a22d91?w=800&h=500&fit=crop',
  'punta cana': 'https://images.unsplash.com/photo-1569700946659-fe1941c71fe4?w=800&h=500&fit=crop',
  'lisboa': 'https://images.unsplash.com/photo-1585208798174-6cedd86e019a?w=800&h=500&fit=crop',
  'gramado': 'https://images.unsplash.com/photo-1668717342589-722a71ddb579?w=800&h=500&fit=crop',
};

export const getDestinationImage = (destination, size = '800x500') => {
  const destLower = destination.toLowerCase();
  for (const [key, url] of Object.entries(DESTINATION_IMAGES)) {
    if (destLower.includes(key)) {
      return size === '1600x900' ? url.replace('w=800&h=500', 'w=1600&h=900') : url;
    }
  }
  // Fallback: use a generic travel image
  return 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=800&h=500&fit=crop';
};
